import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import {
  TippingPointTable_DE,
  TippingPointTable_FR,
} from 'components/Localization/TippingPointTable'
import React from 'react'
import styled from 'styled-components'

export const TippingPointTable = ({
  lang = 'de',
  colorMode = 'light',
}: {
  lang?: 'de' | 'fr'
  colorMode?: 'light' | 'dark' | undefined
}) => {
  const Locales = lang === 'fr' ? TippingPointTable_FR : TippingPointTable_DE
  return (
    <>
      <TextWidth>
        <div className='title'>{Locales.title}</div>
        <StyledTippingPointTable>
        {Locales.entries.slice(0,4).map((entry) => {
            return (
              <div className='wrapper'>
                <div className='mapcontainer'>
                  <div className='letter'>{entry.number}</div>
                </div>
                <div className='textcontainer'>
                  <div className='title'>{entry.title}</div>
                  <div className='text'>{entry.text}</div>
                </div>
              </div>
            )
          })}
          <img src={require('./maps/smallmap_overview.png')} className="map"/>
          {Locales.entries.slice(4).map((entry) => {
            return (
              <div className='wrapper'>
                <div className='mapcontainer'>
                  <div className='letter'>{entry.number}</div>
                </div>
                <div className='textcontainer'>
                  <div className='title'>{entry.title}</div>
                  <div className='text'>{entry.text}</div>
                </div>
              </div>
            )
          })}
        </StyledTippingPointTable>
        <div className='source'>{Locales.source}</div>
      </TextWidth>
    </>
  )
}

const StyledTippingPointTable = styled.div`
  width: 100%;
  font-size: 15px;
  line-height: 1.4em;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 10px;
  img {
    width: 100%;
  }
  .wrapper {
    flex: 0 0 calc(50% - 15px);
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    /* border-bottom: 1px solid var(--gray-3); */
    margin-bottom: 5px;
    @media only screen and (max-width: 724px) {
      flex: 0 0 100%;
      /* margin-left: 20%; */
    }
  }
  .mapcontainer {
    flex: 0 0 20px;
    margin-right: 10px;
  }
  .map{

    margin-top: 30px;
    margin-bottom: 30px;


  }
  .letter {
    color: var(--petrol-main);
    font-size: 30px;
    font-weight: 700;
    display: flex;
    height:100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;

  }
  .textcontainer {
    flex: 0 0 calc(100% - 65px);
    /* height: 100px; */
  }
  .title {
   

    font-weight: 700;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
 
  
    margin: 0;
  }
  .text {
    font-size: 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* height: calc(100% - 2.8em); */
  }
`
